import { desc, sql } from "drizzle-orm";
import { data } from "react-router";
import { z } from "zod";
import { pg } from "~/pg.server";
import { $SERVER } from "~/util/Loaders";
import { $API } from "~/util/Loaders";

export const metrikaApi = $API({
  path: "api/metrika",
  method: "POST",
  parser: z.object({}).strict(),
})(
  $SERVER?.(async (cx) => {
    const since = new Date(Date.now() - 2 * 60 * 1000); // за последние 2 минуты

    const records = await pg.db
      .select({
        id: pg.pageViews.id,
        userAgent: pg.pageViews.userAgent,
        ip: pg.pageViews.ip,
        referer: pg.pageViews.referer,
        path: pg.pageViews.path,
        gver: pg.pageViews.gver,
        lang: pg.pageViews.lang,
        createdAt: pg.pageViews.createdAt,
      })
      .from(pg.pageViews)
      .where(sql`${pg.pageViews.createdAt} >= ${since.toISOString()}`)
      .orderBy(desc(pg.pageViews.createdAt));
    return data({ events: records });
  })
);
